import { prop, assoc } from 'ramda';
import { combineReducers } from 'redux';
import { keyBy, merge } from 'lodash/fp';

import { addItem } from '../../common/helpers/functional';
import {
  FETCH_ALL_MEMBERSHIPS_SUCCESS,
  ARCHIVE_MEMBERSHIP_SUCCESS,
  CREATE_MEMBERSHIP_SUCCESS,
  EDIT_MEMBERSHIP_SUCCESS,
} from './constants';

const byId = (state = {}, { type, payload }) => {
  switch (type) {
    case FETCH_ALL_MEMBERSHIPS_SUCCESS:
      return merge(keyBy('id', payload), state);
    case EDIT_MEMBERSHIP_SUCCESS:
    case CREATE_MEMBERSHIP_SUCCESS:
    case ARCHIVE_MEMBERSHIP_SUCCESS:
      return assoc(payload.id, payload, state);
    default:
      return state;
  }
};

const list = (state = [], { type, payload }) => {
  switch (type) {
    case FETCH_ALL_MEMBERSHIPS_SUCCESS:
      return payload.map(prop('id'));
    case CREATE_MEMBERSHIP_SUCCESS:
      return addItem(payload.id, state);
    case EDIT_MEMBERSHIP_SUCCESS:
    case ARCHIVE_MEMBERSHIP_SUCCESS:
      return state.map(mem => (mem.id === payload.id ? payload : mem));
    default:
      return state;
  }
};

export default combineReducers({ byId, list });
